import { render, staticRenderFns } from "./SubjectAwards.vue?vue&type=template&id=699d5761"
import script from "./SubjectAwards.vue?vue&type=script&lang=ts"
export * from "./SubjectAwards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports